import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PageLoader, LiveRegionContextProvider } from '@sumtotal/react-foundation';
import AppRouter from './AppRouter';
import ThemeContainer from './theme/ThemeContainer';
import store from './state/store';
import UserContextProvider from './contexts/UserContextProvider';
import HeaderContextProvider from './contexts/HeaderContextProvider';
import SettingsContextProvider from './contexts/SettingsContextProvider';
import MessageContextProvider from './contexts/MessageContextProvider';
import BreadcrumbContextProvider from './contexts/BreadcrumbContextProvider';
import IntegrationContextProvider from './contexts/IntegrationContextProvider';

// ----------------------------------------------------------------------

function App() {
  return (
    <Provider store={store}>
      <UserContextProvider>
        <SettingsContextProvider>
          <ThemeContainer>
            <HeaderContextProvider>
              <LiveRegionContextProvider>
                <MessageContextProvider>
                  <IntegrationContextProvider>
                    <BreadcrumbContextProvider>
                      <Suspense fallback={<PageLoader show />}>
                        <AppRouter />
                      </Suspense>
                    </BreadcrumbContextProvider>
                  </IntegrationContextProvider>
                </MessageContextProvider>
              </LiveRegionContextProvider>
            </HeaderContextProvider>
          </ThemeContainer>
        </SettingsContextProvider>
      </UserContextProvider>
    </Provider>
  );
}

export default App;
